import React,{Fragment} from 'react';
import { Form, Input, Button, Alert } from 'antd';
import { oldSendSecondCode,oldSecondLogin } from 'actions/oldAccount';
import LoginCaptchaModal from './LoginCaptchaModal';
import classnames from 'classnames';
import {toUrl} from 'utils/tool.js';
import style from './SecondVerfy.less';
const FormItem = Form.Item;
class SecondVerfy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasSend: false,
            time: 60,
        };
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    //开始倒计时
    startTimer = () => {
        this.setState({
            hasSend: true,
        });
        this.timer = setInterval(() => {
            this.setState((prevState) => ({
                time: prevState.time - 1,
            }), () => {
                if (this.state.time <= 0) {
                    clearInterval(this.timer);
                    this.setState({
                        hasSend: false,
                        time: 60,
                    });
                }
            });
        }, 1000);
    }



    sendCode = () => {
        const { hasSend } = this.state;
        const { info } = this.props;
        if(hasSend) return;
        this.captchaModalRef && this.captchaModalRef.tagget(true,info.username);
    }

    onCaptchaCode = (value,code)=>{
        const params = {
            captcha:code,
            token: this.props.info.step_token,
            send_type:2
        };
        oldSendSecondCode(params).then(()=>{
            this.startTimer();
            this.captchaModalRef && this.captchaModalRef.tagget(false);
        }).catch(err=>{
            this.captchaModalRef && this.captchaModalRef.tagget(false);
            this.errorHander(err.data && err.data.msg);
        });
    }

    errorHander = (errMsg)=>{
        console.log(this.props);
        this.props.onError(errMsg||'error');
        this.setState({loading:false});
    }

    handleSubmit = () => {
        this.props.form.validateFields(['verification_code'], (err, values) => {
            if (!err) {
                this.setState({loading:true,errMsg:null});
                const params = {
                    token:this.props.info.step_token,
                    email_verification_code:values.verification_code
                };
                oldSecondLogin(params).then(() => {
                    // 登陆成功重定向
                    toUrl('/pages');
                }).catch(err => {
                    this.errorHander(err.data && err.data.msg);
                });
            }else{
                let errMsg = '';
                for (const key in err) {
                    if (err.hasOwnProperty(key)) {
                        errMsg = err[key].errors[0].message;
                        break;
                    }
                }
                this.errorHander(errMsg);
            }
        });
    }
    render() {
        const { hasSend, time } = this.state;
        const { info } = this.props;
        const { getFieldDecorator } = this.props.form;
        const inputSendButtonCls = classnames({
            [style.sendButton]: true,
            [style.diabled]: hasSend,
        });
        return (
            <Fragment>

                <FormItem help="" label={'Email verification:'+info.send_email} style={{marginBottom:20}} colon={false}>
                    {getFieldDecorator('verification_code', {
                        rules: [{ required: true, message: 'Please enter the verification code'}],
                        validateTrigger:false
                    })(
                        <Input placeholder='verification code' addonAfter={<a className={inputSendButtonCls}  style={{minWidth:100,display:'inline-block'}} onClick={this.sendCode} >{!hasSend?'Send':`Retry in ${time} seconds`}</a>} />
                    )}
                </FormItem>
                {this.state.errMsg ? <Alert message={this.state.errMsg} type="error" closable style={{margin: '10px 0'}} onClose={this.closeAlert}/>: null}
                <FormItem><Button className={style.indexButton} loading={this.state.loading} type="primary" onClick={this.handleSubmit}>Sign in</Button></FormItem>
                <LoginCaptchaModal
                    ref={(ref)=>this.captchaModalRef = ref}
                    onOk={this.onCaptchaCode}
                />
            </Fragment>
        );
    }

}

export default SecondVerfy;



// WEBPACK FOOTER //
// ./src/pages/Login/SecondVerfy.js